import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isSubmit: false,
    isFetching: false,
    isGetItem: false,
    data: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
    },
    allProducts: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.PRODUCT_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.PRODUCT_CREATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.PRODUCT_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isGetItem: false };
        case Types.PRODUCT_UPDATE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.PRODUCT_DELETE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.PRODUCT_GET_UPDATE_ACTION:
            return { ...state, isFetchingUpdate: true, isGetItem: true };
        case Types.PRODUCT_LIST_SUCCESS:
            return { ...state, isFetching: false, data: action.products, isSubmit: false };
        case Types.PRODUCT_GET_UPDATE_SUCCESS:
            return { ...state, isFetchingUpdate: false, dataUpdate: action.dataUpdate, isGetItem: false, isSubmit: false };
        case Types.PRODUCT_LIST_ALL_SUCCESS:
            return { ...state, isFetchingUpdate: false, allProducts: action.allProducts };
        case Types.PRODUCT_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.PRODUCT_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.PRODUCT_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.PRODUCT_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.PRODUCT_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.PRODUCT_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.PRODUCT_UPDATE_SUCCESS:
            return { ...state, isFetching: false, isSubmit: false };
        default:
            return state;
    }
}
